import React, { useState } from "react";
import { Handshake, ArrowRight } from "lucide-react";
import Reveal from "./Reveal";
import { partner, brand } from "../mock/content";
import PartnerCommercialeModal from "./PartnerCommercialeModal";
import { t } from "../lib/ui";
const PartnerMap = React.lazy(() => import("./PartnerMap").then((m) => ({ default: m.PartnerMap })));

export default function PartnerSection() {
  const [partnerOpen, setPartnerOpen] = useState(false);
  return (
    <section id="partner" className="bg-[#F5F5F3] text-black py-24 md:py-32">
      <PartnerCommercialeModal open={partnerOpen} onClose={() => setPartnerOpen(false)} />
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <Reveal>
          <div className="max-w-2xl">
            <span className="text-black/60 text-[12px] uppercase tracking-[0.28em]" style={{ fontFamily: "Space Grotesk" }}>
              {partner.eyebrow}
            </span>
            <div className="mt-6 flex items-end gap-5">
              <span className="font-black leading-none tracking-tight" style={{ fontFamily: "Archivo", fontSize: "clamp(3.5rem, 9vw, 6.5rem)", color: brand.yellow }}>
                {partner.count}
              </span>
            </div>
            <h2 className="mt-2 font-black leading-[0.95] tracking-tight" style={{ fontFamily: "Archivo", fontSize: "clamp(1.8rem, 3.5vw, 3rem)" }}>
              {partner.title}
            </h2>
            <p className="mt-6 text-black/65 text-lg leading-relaxed" style={{ fontFamily: "Inter" }}>{partner.body}</p>

            <button
              type="button"
              onClick={() => setPartnerOpen(true)}
              data-testid="partner-section-commerciale-cta"
              className="group mt-8 w-full sm:w-auto inline-flex items-center gap-4 border border-black bg-black text-white px-5 py-4 hover:bg-[#F9E212] hover:text-black transition-colors text-left"
            >
              <span className="w-11 h-11 flex items-center justify-center bg-[#F9E212] text-black shrink-0 group-hover:bg-black group-hover:text-[#F9E212] transition-colors">
                <Handshake size={20} />
              </span>
              <span className="flex-1">
                <span className="block text-[11px] uppercase tracking-[0.2em] opacity-60" style={{ fontFamily: "Space Grotesk" }}>{t("pc_cta_eyebrow")}</span>
                <span className="block text-base font-black leading-tight" style={{ fontFamily: "Archivo" }}>{t("pc_cta_title")}</span>
                <span className="block text-[11px] opacity-60 mt-0.5" style={{ fontFamily: "Inter" }}>{t("pc_cta_desc")}</span>
              </span>
              <ArrowRight size={18} className="shrink-0 opacity-50 group-hover:opacity-100 group-hover:translate-x-1 transition-all" />
            </button>
          </div>
        </Reveal>

        <Reveal y={40}>
          <React.Suspense fallback={<div className="h-[420px] bg-white/5" />}><PartnerMap /></React.Suspense>
        </Reveal>
      </div>
    </section>
  );
}
